var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41398 1.16636C10.963 -0.388788 13.4746 -0.388788 15.0236 1.16636C16.5227 2.67135 16.5711 5.08124 15.1684 6.64489L15.0233 6.79837L7.72829 14.1141C6.79892 15.0471 5.29212 15.0471 4.36275 14.1141C3.47379 13.2217 3.43514 11.7988 4.24709 10.8599L4.36308 10.735L11.0954 3.98418C11.4053 3.67347 11.9074 3.67377 12.2168 3.98485C12.5005 4.27 12.5239 4.71731 12.2872 5.0292L12.2162 5.11069L5.48418 11.8612C5.17416 12.1724 5.17416 12.677 5.48418 12.9883C5.76836 13.2736 6.2144 13.2973 6.5258 13.0594L6.60716 12.988L13.9022 5.67222C14.8319 4.73885 14.8319 3.22557 13.9022 2.2922C13.0129 1.39942 11.5951 1.3606 10.6599 2.17575L10.5354 2.2922L3.248 9.60825C1.69859 11.1637 1.69859 13.6857 3.248 15.2412C4.74743 16.7465 7.14842 16.7951 8.70602 15.3869L8.8589 15.2412L16.1463 7.92515C16.456 7.61426 16.9581 7.61426 17.2677 7.92515C17.5516 8.21014 17.5753 8.65743 17.3387 8.96947L17.2677 9.05099L9.98033 16.367C7.81157 18.5443 4.29532 18.5443 2.12657 16.367C0.01342 14.2456 -0.0407634 10.8398 1.96402 8.65252L2.12657 8.48241L9.41398 1.16636Z",
    fill: "#77928B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach-file.2ffc90766c22b1dbdd3bb143b2c34e80.svg";
export { ForwardRef as ReactComponent };